import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-tc-accordion',
  templateUrl: './tc-accordion.component.html',
  styleUrls: ['./tc-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, AsyncPipe],
})
export class TcAccordionComponent implements OnInit {
  content$: Observable<any> = this.component.data$;
  collapsedHeight = '56px';
  expandedHeight = '56px';

  constructor(public component: CmsComponentData<any>) {}

  ngOnInit() {}
}
